
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]",
      function () {
        return require("private-next-pages/_sites/[site]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]"])
      });
    }
  